import Vue from 'vue'
import Service from './Service.vue'
import '@/assets/common/css/common.less'
import '@/plugins/fontsLoader'

Vue.config.productionTip = false

new Vue({
  render: (h) => h(Service)
}).$mount('#Service')
